import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { allUsersRoute, host } from "../utils/API_Routes";
import ChatContainer from "../components/ChatContainer";
import Contacts from "../components/Contacts";
import Welcome from "../components/Welcome";
import { io } from 'socket.io-client';
import useAxiosPrivate from "../hooks/usePrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { removeUser, setOnlineUsers } from "../features/user/userSlice";
import { setContacts, setIsContactsLoading } from "../features/chat/chatSlice";

const Chat = () => {
    const socket = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const { currentChat } = useSelector((state) => state.chat)
    const axiosPrivate = useAxiosPrivate();
    const { user } = useSelector((state) => state.user)
    const dispatch = useDispatch();
    const [displayContacts, setDisplayContacts] = useState(false);
    useEffect(() => {
        if (!user) {
            return navigate("/login");
        }
        socket.current = io(host);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (user) {
            socket.current.emit('add-user', user._id);
            socket?.current?.on('online-users', (data) => {
                dispatch(setOnlineUsers(data))
            })
            const getUser = async () => {
                return await axiosPrivate.get(`${allUsersRoute}/${user._id}`, { withCredentials: true });
            }
            if (user.isAvatarImageSet) {
                dispatch(setIsContactsLoading(true))
                getUser().then((data) => {
                    dispatch(setContacts(data.data));
                    dispatch(setIsContactsLoading(false))
                }).catch((err) => {
                    dispatch(setIsContactsLoading(false))
                    console.log(err);
                    navigate('/login', { state: { from: location }, replace: true });
                    dispatch(removeUser())
                    socket.current.disconnect();
                });
            } else {
                navigate("/setAvatar");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])
    return (
        <>
            <Wrapper>
                <div className="container">
                    <ContactsDiv displayContacts={displayContacts}>
                        <Contacts setDisplayContacts={setDisplayContacts} />
                    </ContactsDiv>
                    {
                        currentChat === undefined ? <Welcome setDisplayContacts={setDisplayContacts} /> : <ChatContainer socket={socket} setDisplayContacts={setDisplayContacts} />
                    }
                </div>
            </Wrapper>
        </>
    );
}
const ContactsDiv = styled.div`
    @media screen and (max-width:720px){
        z-index:100 ;
        display:${({ displayContacts }) => !displayContacts && "none"};
        position:${({ displayContacts }) => displayContacts && "fixed"};
        width:inherit ;
    }
`
const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  .container {
    height: 85vh;
    width: 85vw;
    background-color: #00000076;
    display: grid;
    grid-template-columns: 25% 75%;
    @media screen and (min-width: 720px) and (max-width: 1080px) {
      grid-template-columns: 35% 65%;
    }
  }
  @media screen and (max-width:720px){
    .container {
        grid-template-columns: 100%;
    }
  }
`;

export default Chat